import { adjustBrightness, makeTranslucent } from '../utils/colors';

// Background grays.
export const AXLE_PAGE_BACKGROUND_GRAY = '#FaFaFa';
export const MEDIUM_GRAY_BACKGROUND_FOR_CONTAINERS = '#F4F4F4';
export const LIGHT_GRAY_BACKGROUND_FOR_CONTAINERS = '#F0F0F0';
export const DEFAULT_HEADER_FOOTER_BACKGROUND_FOR_TABLES = '#f1f5f9';

// Text grays.
export const TEXT_GRAY = '#828283';

// Icon grays.
export const ICON_GRAY = '#828282';
export const ICON_LIGHT_GRAY = makeTranslucent(TEXT_GRAY, 0.4);

// Reds.
export const AXLE_RED = '#EB5757';

// Teals.
export const LIGHT_AXLE_TEAL_BACKGROUND = '#E7F5F5';
export const AXLE_TEAL = '#66C1BF';
export const DARK_AXLE_TEAL = adjustBrightness(AXLE_TEAL, -100);

// Priorities
export const AXLE_PRIORITY_STANDARD = '#E7F5F4';
export const AXLE_PRIORITY_HIGH = '#B6E0DF';
export const AXLE_PRIORITY_URGENT = '#83CBC9';

// Visit issue highlighting reds and oranges.
export const VISIT_UNASSIGNED_ICON_COLOR = 'rgb(238, 67, 54)';
export const VISIT_UNASSIGNED_BACKGROUND_COLOR = 'rgba(238, 67, 54, 0.05)';
export const VISIT_LATE_ICON_COLOR = 'rgb(233,169,58)';
export const VISIT_LATE_BACKGROUND_COLOR = '#fafce5d9';

// This color is the same as the "High Priority" color in the <PriorityChip/>,
//  hardcoded in the back-end.  We don't have centralized alerting/alert colors in the
//  front-end, so we're just using this color for now.
export const HIGH_PRIORITY_COLOR = '#F27E7E';

// Darkest to lightest colors
export const WEEKDAY_FADING_COLOR_PALETTE = ['#94DBD8', '#C0E5E2', '#D6E6E5'];
export const FADING_COLOR_PALETTE_EXTENDED = [AXLE_TEAL, '#94DBD8', '#C0E5E2', '#D6E6E5'];

// Links
export const BLUE_LINK = '#0062FF';
export const BLUE_LINK_HOVER = adjustBrightness(BLUE_LINK, -40);
